import { createSlice } from "@reduxjs/toolkit";

import { LOCAL_STORAGE_KEYS } from "../../Util/constants";

const initialState = {
  selectedNewsie: null
};
export const selectedNewsieSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.SELECTED_NEWSIE,
  initialState,
  reducers: {
    setSelectedNewsie: (state, action) => {
      state.selectedNewsie = action.payload;
    }
  },
});
// Action creators are generated for each case reducer function
export const {
  setSelectedNewsie
} = selectedNewsieSlice.actions;

export default selectedNewsieSlice.reducer;
